module.exports = __webpack_public_path__ + "static/media/EYInterstate-Light.29e0c0b4.woff2";